import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { AdminDashboardStats } from '../../core/models/admin-stats.models';
import { AdminStatsService } from '../../core/services/admin-stats.service';

@Component({
  selector: 'app-stats-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stats-page.component.html',
  styleUrl: './stats-page.component.scss',
})
export class StatsPageComponent implements OnInit {
  private readonly statsService = inject(AdminStatsService);

  stats: AdminDashboardStats | null = null;
  loading = false;
  errorMessage = '';

  ngOnInit(): void {
    this.reload();
  }

  reload(): void {
    this.loading = true;
    this.errorMessage = '';

    this.statsService.getDashboardStats().subscribe({
      next: (stats) => {
        this.stats = stats;
      },
      error: (error) => {
        this.errorMessage = error?.error?.message ?? 'Impossible de charger les statistiques.';
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  ratio(part: number | undefined, total: number | undefined): number {
    const safePart = part ?? 0;
    const safeTotal = total ?? 0;
    if (safeTotal <= 0) {
      return 0;
    }
    return Math.max(0, Math.min(100, Math.round((safePart * 100) / safeTotal)));
  }
}
